import React from "react";
import _ from "lodash";

import FluserUser from "../components/FluserUser";

import {around_horn} from "../../../assets/images/fluster";

const AroundTheHornIntro = ({ parameters, answerer_player_details }) => {
  const display_name = _.get(answerer_player_details, "display_name");
  const profile_image = _.get(answerer_player_details, "profile_image");

  const around_the_horn = _.get(
    parameters,
    "8_aroundthehornintro.around_the_horn",
    "AROUND THE HORN"
  );
  const info = _.get(
    parameters,
    "8_aroundthehornintro.info",
    " has played Around The Horn Card! Now Everyone gets to answer!"
  );
  return (
    <div className="fluster-intro aroundthe-horn">
      <div className="top-content">
        <div className="left-content">
          <FluserUser display_name = {display_name} profile_image = {profile_image}/>
        </div>
        <div className="middle-content">
          <h1>{around_the_horn}</h1>
          <img src={around_horn} alt="" />
        </div>
        <div className="right-content">
          <p className="aroundhorn-text">
            <span>{display_name}</span> {info}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AroundTheHornIntro;
